import { DashboardLayout } from "@/components/DashboardLayout";
import { useCoverageIntelligence } from "@/hooks/useCoverageIntelligence";
import CoverageQueue from "@/pages/coverage/CoverageQueue";
import CoverageWorkspace from "@/pages/coverage/CoverageWorkspace";
import { toast } from "sonner";

export default function CoverageIntelligence() {
  const ci = useCoverageIntelligence();

  const handleOpen = async (patient) => {
    try {
      await ci.openPatient(patient);
    } catch (err) {
      toast.error(err.response?.data?.detail?.message || "Failed to load coverage patient");
    }
  };

  const handleVerify = async (patient) => {
    try {
      toast.info("Verifying coverage via Priorath BFF…");
      await ci.verifyPatient(patient);
      toast.success("Coverage verification completed.");
    } catch (err) {
      toast.error(err.response?.data?.detail?.message || "Coverage verify failed");
    }
  };

  const handleResolve = async (reviewId, body) => {
    try {
      await ci.resolveReview(reviewId, body);
      toast.success("Review correction submitted.");
    } catch (err) {
      toast.error(err.response?.data?.detail?.message || "Review resolve failed");
      throw err;
    }
  };

  return (
    <DashboardLayout>
      {!ci.activePatient ? (
        <CoverageQueue
          patients={ci.patients}
          loading={ci.queueLoading}
          error={ci.queueError}
          forbidden={ci.forbidden}
          source={ci.source}
          tenant={ci.tenant}
          onRefresh={ci.loadQueue}
          onOpen={handleOpen}
          onVerify={handleVerify}
          verifyingId={ci.verifyingPatientId}
        />
      ) : (
        <CoverageWorkspace
          workspace={ci.workspace}
          loading={ci.workspaceLoading}
          verifyLoading={ci.verifyLoading}
          onBack={ci.closePatient}
          onVerify={() => handleVerify(ci.activePatient)}
          onResolve={handleResolve}
        />
      )}
    </DashboardLayout>
  );
}
